export const SUPERVISOR_WORKSPACE_BASE = "/SLN/Supervisor";

/**
 * Primary workspace sections for supervisor panel.
 * Labels: داشبورد / پروژه‌های جاری / پروژه‌های قبلی
 */
export const SUPERVISOR_WORKSPACE_NAV_ITEMS = [
  {
    id: "dashboard",
    labelFa: "داشبورد",
    path: SUPERVISOR_WORKSPACE_BASE,
    matchPaths: [SUPERVISOR_WORKSPACE_BASE, `${SUPERVISOR_WORKSPACE_BASE}/dashboard`],
  },
  {
    id: "projects",
    labelFa: "پروژه‌های جاری",
    path: `${SUPERVISOR_WORKSPACE_BASE}/RequestList/ProjectAssignments`,
    matchPaths: [
      `${SUPERVISOR_WORKSPACE_BASE}/RequestList/ProjectAssignments`,
      `${SUPERVISOR_WORKSPACE_BASE}/ProjectAssignments`,
    ],
  },
  {
    id: "closedProjects",
    labelFa: "پروژه‌های قبلی",
    path: `${SUPERVISOR_WORKSPACE_BASE}/RequestList/ProjectAssignments/Closed`,
    matchPaths: [
      `${SUPERVISOR_WORKSPACE_BASE}/RequestList/ProjectAssignments/Closed`,
      `${SUPERVISOR_WORKSPACE_BASE}/ProjectAssignments/Closed`,
    ],
  },
];

const normalizePath = (pathname) =>
  (pathname || "").toLowerCase().replace(/\/+$/, "") || "/";

const pathMatches = (pathname, candidates) => {
  const path = normalizePath(pathname);
  return (candidates || []).some((p) => {
    const n = normalizePath(p);
    return path === n || path.startsWith(`${n}/`);
  });
};

export const isSupervisorWorkspaceNavSelected = (item, pathname) => {
  const path = normalizePath(pathname);
  const candidates = (item.matchPaths || [item.path]).map(normalizePath);

  if (item.id === "dashboard") {
    return candidates.some((p) => path === p);
  }

  // پروژه‌های قبلی is more specific than پروژه‌های جاری
  if (item.id === "projects") {
    const closedItem = SUPERVISOR_WORKSPACE_NAV_ITEMS.find(
      (x) => x.id === "closedProjects"
    );
    if (pathMatches(pathname, closedItem?.matchPaths)) {
      return false;
    }
  }

  return candidates.some((p) => path === p || path.startsWith(`${p}/`));
};
